module.exports = "/images/vendor/flag-icon-css/flags/4x3/ir.svg?23e0f96c3fa45df393a3c1d184b2df34";